import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";

export default function VehiclesByCoverageTypeAdvanced(props) {
    const device = useContext(DeviceContext);
    const isQuote = props.type === "Quotes";
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    
    const GetData = async () => {
        const response = await CallAPI("POST", `/Advanced/GetVehiclesByCoverageType${props.type}`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            if (isQuote) {
                const formattedResponse = response.map((row) => [
                    row.groupBy,
                    integer.format(row.liabilityOnlyVehiclesQuoted),
                    percent.format(row.liabilityOnlyPercentage / 100),
                    currency.format(row.liabilityOnlyAvgPremium),
                    percent.format(row.liabilityOnlyBindPercentage / 100),
                    integer.format(row.collCompVehiclesQuoted),
                    percent.format(row.collCompPercentage / 100),
                    currency.format(row.collCompAvgPremium),
                    percent.format(row.collCompBindPercentage / 100),
                    integer.format(row.compOnlyVehiclesQuoted),
                    percent.format(row.compOnlyPercentage / 100),
                    currency.format(row.compOnlyAvgPremium),
                    percent.format(row.compOnlyBindPercentage / 100),
                ]);

                setData(formattedResponse);
            } else {
                const formattedResponse = response.map((row) => [
                    row.groupBy,
                    integer.format(row.liabilityOnlyVehiclesBound),
                    percent.format(row.liabilityOnlyPercentage / 100),
                    currency.format(row.liabilityOnlyAvgPremium),
                    integer.format(row.collCompVehiclesBound),
                    percent.format(row.collCompPercentage / 100),
                    currency.format(row.collCompAvgPremium),
                    integer.format(row.compOnlyVehiclesBound),
                    percent.format(row.compOnlyPercentage / 100),
                    currency.format(row.compOnlyAvgPremium),
                ]);

                setData(formattedResponse);
            }
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={"VEHICLES BY COVERAGE TYPE - " + props.type.toUpperCase()}
                exportName={`VehiclesByCoverageType${props.type}`}
                loading={loading}
                rowsPerPage={32}
                fixedColumns={1}
                style={{
                    Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                    Table: {
                        Header: { minWidth: isQuote ? "120px" : "160px" },
                    }
                }}
                headers={[
                    [
                        { text: props.groupBy, rowspan: 2 },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Liability Only</b><TooltipButton tooltipText={"Quotes in which comp/coll not present on any vehicles"} /></h5>),
                            colspan: isQuote ? 4 : 3, style: { width: "auto", textAlign: "center" }
                        },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Coll/Comp</b><TooltipButton tooltipText={"Quotes where at least one vehicle has comp/coll"} /></h5>),
                            colspan: isQuote ? 4 : 3, style: { width: "auto", textAlign: "center", borderLeft: "solid thin" }
                        },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Comp Only</b><TooltipButton tooltipText={"Quotes where at least one vehicle has comp only, if one vehicle has comp/coll and the other has liability only, it'll be under comp/coll"} /></h5>),
                            colspan: isQuote ? 4 : 3, style: { width: "auto", textAlign: "center", borderLeft: "solid thin" }
                        },
                    ],
                    isQuote ? [
                        "Vehicles", "%", "Avg Prem", "Bind %",
                        "Vehicles", "%", "Avg Prem", "Bind %",
                        "Vehicles", "%", "Avg Prem", "Bind %"
                    ] : [
                        "Vehicles", "%", "Avg Prem",
                        "Vehicles", "%", "Avg Prem",
                        "Vehicles", "%", "Avg Prem"
                    ]
                ]}
                rows={data.filter(x => x[0] !== "Total")}
                footers={data.filter(x => x[0] === "Total")}
            />
        </div>
    );
};